export default __webpack_public_path__ + "static/media/white.96af66b1.png";